export default __webpack_public_path__ + "images/e41170de4344bea4cabf08d3376635aa.png";